// src/components/Hero.jsx
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { styles } from "../styles";
import { ComputersCanvas } from "./canvas";

const Hero = () => {
  const { t } = useTranslation();

  // Scroll suave hasta la sección #tech
  const scrollToTech = (e) => {
    e.preventDefault();
    const el = document.getElementById("tech");
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      // por si el DOM de tech aún no está listo
      setTimeout(() => {
        document
          .getElementById("tech")
          ?.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 50);
    }
  };

  return (
    <section className="relative w-full min-h-[100svh] mx-auto overflow-hidden">
      <div
        className={`absolute inset-x-0 top-[112px] sm:top-[145px] lg:top-[170px] max-w-7xl mx-auto ${styles.paddingX} flex flex-row items-start gap-5`}
      >
        <div className="flex flex-col justify-center items-center mt-5" />
        <div className="min-w-0 max-w-4xl">
          {/* Título */}
          <h1 id="hero-section" className={styles.heroHeadText}>
            {t("hero.title")}
          </h1>
          <br />
          {/* Subtítulo */}
          <p
            className={`${styles.heroSup2Text} mt-3 text-white-100`}
            style={{ color: "white", lineHeight: "1.5" }}
          >
            {t("hero.subtitle")}
          </p>
        </div>
      </div>

      {/* Canvas */}
      <div className="absolute inset-x-0 bottom-[-120px] sm:bottom-[-190px] lg:bottom-[-250px] flex justify-center items-center">
        <div className="w-[760px] h-[460px] max-w-[145vw] sm:w-[1200px] sm:h-[700px] md:w-[1500px] md:h-[850px] lg:w-[1800px] lg:h-[1100px]">
          <ComputersCanvas />
        </div>
      </div>

      {/* Indicador de desplazamiento → ahora apunta a #tech */}
      <div className="absolute xs:bottom-10 bottom-8 sm:bottom-10 w-full flex justify-center items-center">
        <button onClick={scrollToTech} aria-label="Ir a Tech">
          <div className="w-[35px] h-[64px] rounded-3xl border-4 border-secondary flex justify-center items-start p-2">
            <motion.div
              animate={{ y: [0, 24, 0] }}
              transition={{ duration: 1.25, repeat: Infinity, repeatType: "loop" }}
              className="w-3 h-3 rounded-full bg-secondary mb-1"
            />
          </div>
        </button>
      </div>
    </section>
  );
};

export default Hero;
